import { IstanzaSezioneDati } from '@framework/api-client';
import {
  FillableWidgetList,
  WidgetScopeContextProvider,
} from '@framework/engine';
import React from 'react';
import { DeclarationTitle } from './DeclarationTitle';
import { DeclarationWrapper } from './DeclarationWrapper';

export interface IProcedureDeclarationSectionProps {
  declaration: IstanzaSezioneDati;
}

export function ProcedureDeclarationSection(
  props: IProcedureDeclarationSectionProps,
) {
  const { declaration } = props;

  return (
    <DeclarationWrapper key={declaration.codiceSezioneDati}>
      <DeclarationTitle
        declaration={declaration}
        title={declaration.titoloSezioneDati ?? 'Dichiarazione'}
      />
      <WidgetScopeContextProvider prefix={`${declaration.idSezioneDati}.`}>
        <FillableWidgetList
          widgets={declaration.jsonCampi?.children ?? []}
          readonly
        />
      </WidgetScopeContextProvider>
    </DeclarationWrapper>
  );
}
